/**
 * Tenant-scoped endpoints (Phase 43.4).
 *
 * Distinct from adminTenants.js — that module is super-admin CRUD over
 * `/api/admin/tenants/*`. This module is for the ONE endpoint that every
 * authenticated user of a tenant can call: GET /api/tenant/status, which
 * drives the setup-incomplete banner.
 */

import { request } from "./api.js";

export const getTenantStatus = () => request("/api/tenant/status");
